import { type CvVoluntaryWork } from '../../types';

export const CvVoluntaryWorkData: CvVoluntaryWork[] = [
  {
    position: 'Board Member',
    longDescription:
      'Representing the Business Relation Committee in board the at the student organization Online. Responsible for ensuring that business relations are prioritized in the daily management of the organization.',
    institution: 'Online',
    location: 'Trondheim',
    startTime: { year: 2022, month: 10 },
    endTime: { year: 2023, month: 10 },
    logo: '',
  },
  {
    position: 'Member of the Business Relation Committee',
    longDescription:
      'Working in the Business relation committee to improve the relationship between the students and the companies. Helping the companies with hosting events and workshops for the students, publishing job advertisements and more.',
    institution: 'Online',
    location: 'Trondheim',
    startTime: { year: 2022, month: 5 },
    logo: '',
  },
  {
    position: 'Board Member at KiD - student-business network',
    longDescription:
      'Representing my student organization, Online, in the student-business network KiD. KiD is a network of 3 student organizations in Trondheim and about 25 companies. The network is working to improve the relationship between the students and the companies to promote motivation and learning outcome in the lower levels of the studies. ',
    institution: 'IE-faculty NTNU',
    location: 'Trondheim',
    startTime: { year: 2022, month: 8 },
    endTime: { year: 2024, month: 6 },
    logo: '',
  },
  {
    position: 'Member of the Excursion Committee',
    longDescription:
      'Working in the Excursion Committee to organize the yearly excursion for the informatic-students. Mainly working with planning and hosting Tech Talks, a series of events where companies come to the university to present themselves and their work to support the excursion. ',
    institution: 'Online',
    location: 'Trondheim',
    startTime: { year: 2023, month: 4 },
    endTime: { year: 2023, month: 4 },
    logo: '',
  },
  {
    position: 'Grill Event Coordinator for the Welcome Committee',
    longDescription:
      'Was grill event coordinator in "Fadderukene" for the student organization. Arranged grill events for 200 new informatics-students. ',
    institution: 'Online',
    location: 'Trondheim',
    startTime: { year: 2022, month: 1 },
    endTime: { year: 2022, month: 9 },
    logo: '',
  },
  {
    position: 'Leader/Board Member',
    longDescription:
      'Onlinefondet is a fund that supports the student organization Online. As a board member, I am responsible for evaluating applications for funding and deciding on the allocation of funds. Leader of the fund from March 2025. ',
    institution: 'Onlinefondet',
    location: 'Trondheim',
    startTime: { year: 2024, month: 3 },
    endTime: { year: 2026, month: 3 },
    logo: '',
    readMoreURL: 'https://www.onlinefondet.no/',
  },
  {
    position: 'Chairman',
    longDescription:
      'Chairman in the condominium association for the building I live in. Responsible for leading the board and ensuring that the condominium association is well-managed and that the interests of the residents are represented.',
    institution: 'Sameiet Nidarøygata 10',
    location: 'Trondheim',
    startTime: { year: 2025, month: 3 },
    logo: '',
  },
];
